import ReactGA from 'react-ga';
import config from '../../../config';

class GoogleAnalytics {
  constructor(googleAnalytics) {
    googleAnalytics.initialize(config.googleAnalyticsID, { testMode: process.env.NODE_ENV === 'test' });
    this.googleAnalytics = googleAnalytics;
  }

  logPageView(page) {
    this.googleAnalytics.set({ page });
    this.googleAnalytics.pageview(page);
  }

  event(event) {
    return this.googleAnalytics.event(event);
  }
}

const googleAnalytics = new GoogleAnalytics(ReactGA);
export default googleAnalytics;



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/googleAnalytics.js